import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentPage = (pageIndex: number) =>
  store.dispatch(appActions.setCurrentPage(pageIndex));

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "computerWithEyeAndChip",
    iconColor: "white",
    text: '<span style="font-weight: bold;">Transparency \nand Clarity</span>\nObtain visibility over \nhow AI makes decisions, \nwhat data is being used \nand overall impact',
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "personFocusedWithCheckmark",
    iconColor: "white",
    text: '<span style="font-weight: bold;">Safeguarding Human \nRights</span>\nOur AI models prevent \nharm in human rights \nareas like privacy, safety \nand harm prevention',
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "puzzle",
    iconColor: "white",
    text: '<span style="font-weight: bold;">Fairness </span>\nAI models provide \nunbiased outputs that \nare fair to all \nstakeholders',
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const data = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  styleLeftPanel: { paddingRight: 0 },
  title: "Infosys Responsible AI",
  text: "Our responsible AI suite of offerings is built on the AI3S framework, helping \nenterprises reduce the risks of their AI investments and embed strong \ntechnical and policy guardrails for effective AI governance.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  styleListData: { marginTop: "50px" },
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage(302),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(1),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_01.png",
};

export default data;
